// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1sWdA","row":"ProcedureTreatmentSummary_row__2xVlX"};